export default __webpack_public_path__ + "static/media/Group449.85746882.png";